import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import BreadcrumbsContainer from '../common/breadcurmbs/BreadcrumbsContainer';
import ApprovalLineTemplateTab from '../../components/attendancemng/ApprovalLineTemplateTab';
import ApprovalLineTemplateModal from '../../components/attendancemng/ApprovalLineTemplateModal';
import * as approvalV2Api from '../../lib/api/approvalV2';

const ApprovalLineTemplateContainer = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { user } = useSelector(({ auth }) => ({ user: auth.user }));

  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedLine, setSelectedLine] = useState(null);
  const [docTypeFilter, setDocTypeFilter] = useState('');

  const fetchList = async () => {
    setLoading(true);
    try {
      const res = await approvalV2Api.getApprovalV2Lines(docTypeFilter ? { docType: docTypeFilter } : {});
      setList(res.data.list || []);
    } catch (e) {
      enqueueSnackbar('v2 결재선 템플릿 조회 실패', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [docTypeFilter]);

  const handleSave = async (values) => {
    try {
      if (selectedLine) {
        await approvalV2Api.editApprovalV2Line(selectedLine.lineId, values);
        enqueueSnackbar('v2 결재선 템플릿을 수정했습니다.', { variant: 'success' });
      } else {
        await approvalV2Api.addApprovalV2Line(values);
        enqueueSnackbar('v2 결재선 템플릿을 등록했습니다.', { variant: 'success' });
      }
      setModalOpen(false);
      setSelectedLine(null);
      fetchList();
    } catch (e) {
      enqueueSnackbar(e?.response?.data?.message || 'v2 결재선 템플릿 저장에 실패했습니다.', { variant: 'error' });
    }
  };

  const handleDelete = async (row) => {
    try {
      await approvalV2Api.removeApprovalV2Line(row.lineId);
      enqueueSnackbar('v2 결재선 템플릿을 삭제했습니다.', { variant: 'success' });
      fetchList();
    } catch (e) {
      enqueueSnackbar(e?.response?.data?.message || 'v2 결재선 템플릿 삭제에 실패했습니다.', { variant: 'error' });
    }
  };

  return (
    <>
      <BreadcrumbsContainer title="결재관리/결재선 템플릿" />
      <ApprovalLineTemplateTab
        list={list}
        loading={loading}
        docTypeFilter={docTypeFilter}
        onDocTypeFilterChange={setDocTypeFilter}
        onAdd={() => {
          setSelectedLine(null);
          setModalOpen(true);
        }}
        onEdit={(row) => {
          setSelectedLine(row);
          setModalOpen(true);
        }}
        onDelete={handleDelete}
      />
      <ApprovalLineTemplateModal
        open={modalOpen}
        data={selectedLine}
        currentUserUuid={user?.usrUuid || ''}
        onClose={() => {
          setModalOpen(false);
          setSelectedLine(null);
        }}
        onSave={handleSave}
      />
    </>
  );
};

export default ApprovalLineTemplateContainer;
